import * as React from 'react'
import styled from '../theme'

interface IButtonProps {
  isFailure: boolean
  editStyle?: boolean
}

interface ISignupOutcome {
  theme: {
    content: {
      Borders_hover_colour: string
      Font: string
    }
  }
  onClick: () => void
  isFailure: boolean
  content: string
  buttonContent: string
  handleFailureClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}
export const SignupOutcome = (props: ISignupOutcome) => (
  <Wrapper theme={props.theme}>
    <Body theme={props.theme}>{props.content}</Body>
    <ButtonWrapper>
      <NextButton onClick={props.onClick} theme={props.theme} isFailure={props.isFailure}>
        {props.isFailure ? props.buttonContent : 'SIGNUP'}
      </NextButton>
      { 
        props.isFailure && 
        <NextButton 
          isFailure={props.isFailure} 
          onClick={props.handleFailureClick} 
          editStyle={true}
          theme={props.theme}>
          Edit Address
        </NextButton> 
      }
    </ButtonWrapper>
  </Wrapper>
)

const Wrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 100vw;
  max-width: 653px;
  align-items: center;
  background: white;
  margin-top: 15px;
  padding-bottom: 12px;
  border: 2px solid ${(props: any) => props && props.theme && props.theme.content && props.theme.content.Borders_hover_colour};
  @media (max-width: 768px) {
    width: calc(100% - 10px);
    margin-top: 45px;
  }
  `

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
const Body = styled.p`
    font-size: 16px;
    text-align: center;
    font-family: tourismbody;
    color: ${(props: any) => JSON.parse(props.theme.content.colors).Borders_hover_colour};
    width: 80%;
    overflow: auto;

    @media (max-width: 550px) {
        width: 100%;
        margin: 1em 0;
    }
`
export const NextButton = styled<IButtonProps, 'button'>('button')`
    width: ${(props: IButtonProps) => props.isFailure? '50%%': '100%'};
    height: 41px;
    padding-bottom: 0px;
    padding-left: 35px;
    margin-right: 22px;
    padding-right: 35px;
    font-family: tourismcta;
    text-align: center;
    white-space: nowrap;
    color: ${(props: any) => props.editStyle ? 
      props && props.theme && props.theme.content && props.theme.content.Borders_hover_colour : 'white'}
    background: ${(props: any) => props.editStyle ?
      'white' :
      props && props.theme && props.theme.content && props.theme.content.Borders_hover_colour}
    border: ${(props: any) => props.theme && props.theme.content && 
      '1px solid '+ props.theme.content.Borders_hover_colour}
    font: ${(props: any) => props && props.theme && props.theme.content && props.theme.content.Font}
    &:disabled {
      opacity: 0.5
    }
    &:focus {
      outline: none;
    }
    @media (max-width: 768px) {
      white-space: nowrap;
      margin-right: 4px;
    }
`



// WEBPACK FOOTER //
// ./src/components/SignupOutcome.tsx